<template>
    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Form details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <div>
                </div>
            </div>
        </div>
        <div class="mcc-container card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Forms</a>
                    </li>
                    <li aria-current="page">Create new</li>
                </ol>
            </nav>
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>
            <div class="relativePosition">
                <div v-if="saveInProgress" class="spinner-overlay zIndex10">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex spinner-text">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>

                    </div>

                </div>
                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <form @submit.prevent="saveForms()" v-show="fetchCall" id="formId" novalidate>


                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Details</h2>
                                </div>
                                <div class="mcc-card__body">

                                    <div
                                        class="mfc-slim-select-wrapper mu-mb-05 mfc-form-input-container mfc-form-input-wrapper--width">
                                        <label for="applicationId" class="mfc-label--required">Application</label>
                                        <select @change="applicationSlimSelector($event)" ref="appdropdownRef"
                                            name="application" id="applicationId" required block>
                                            <option data-placeholder="true" value :selected="selectedApp == ''"></option>
                                            <option v-for="(app, key) in applications" :selected="selectedApp == app.id"
                                                :key="key" :value="app.id">{{ app.name }}</option>
                                        </select>

                                    </div>
                                    <div class="mcc-row" v-for="(item, index) in applicationForms.forms" :key="index">
                                        <div class="mcc-col-auto">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap"
                                                style="width: 300px;">
                                                <label :for="getFormKeyName(index)" class="mfc-label--required">Form
                                                    key</label>
                                                <input type="text" maxlength="50" required="" ref="formKey"
                                                    :id="getFormKeyName(index)" :name="getFormKeyName(index)"
                                                    :pattern="formKeyRegex" :value="item.key"
                                                    @change="updateKey($event, index)">

                                            </div>
                                        </div>
                                        <div class="mcc-col">

                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container"
                                                style="width: 300px;">
                                                <label :for="getFormName(index)" class="mfc-label--required">Form
                                                    name</label>
                                                <input type="text" maxlength="50" required="" ref="formName"
                                                    :id="getFormName(index)" :name="getFormName(index)"
                                                    :pattern="nameRegex" :value="item.name"
                                                    @change="updateFormName($event, index)">
                                            </div>
                                        </div>


                                    </div>
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mu-d-flex mu-justify-content-end ">
                                                <div role="group"
                                                    class="mcc-button-group mu-mt-03 mcc-button-group--spaced">
                                                    <router-link :to="CONTEXT_PATH + '/design/forms'">
                                                        <button class="mcc-button mcc-button--outline mu-mr-05"
                                                            title="Cancel" id="cancelBtn">
                                                            <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span
                                                                class="mcc-button__label">Cancel</span>
                                                        </button>
                                                    </router-link>
                                                    <button class="mcc-button mcc-button--success " title="Save"
                                                        id="saveBtn" type="submit">
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span
                                                            class="mcc-button__label">Save</span>
                                                    </button>

                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>

<script>
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "MultipleFormCopy",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["application.form.copy"],
            nameRegex: constantMessages.PATTERNS["name"],
            formKeyRegex: constantMessages.PATTERNS["nameWithoutSpaces"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            applicationForms: [],
            applications: [],
            fetchCall: false,
            saveInProgress: false,
            selectedApp: "",
            selectInstance: null
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (this.$route.params.otherProps != undefined) {
            let selectedForms = this.$route.params.otherProps.formIds;
            this.selectedApp = this.$route.params.otherProps.appToCopyId;
            if (selectedForms != null && selectedForms.length > 0) {
                ApplicationFormAPI.getMultipleCopyInfo(selectedForms)
                    .then(result => {
                        self.applicationForms = result;
                        self.applications = result.applications;
                    })
                    .finally(() => {
                        self.fetchCall = true;
                    });
            } else {
                self.$router.push(this.CONTEXT_PATH + "/design/forms");
            }
        } else {
            self.fetchCall = true;
            self.$router.push(this.CONTEXT_PATH + "/design/forms");
        }
        this.selectInstance = new SlimSelect({
            select: '#applicationId'
        });
    },
    methods: {

        applicationSlimSelector(e) {
            let self = this
            if (self.$refs.appdropdownRef.value != "") {
                self.$refs.appdropdownRef.classList.remove("ms-is-invalid")
            }
            this.selectedApp = e.target.value
        },
        saveForms() {
            let form = $('#formId')
            let self = this;

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.saveInProgress = true;
            self.applicationForms.applicationId = self.selectedApp;
            let formContents = JSON.parse(JSON.stringify(self.applicationForms));
            formContents.applications = [];
            ApplicationFormAPI.saveMultipleCopy(formContents)
                .then(response => {
                    self.saveInProgress = false;
                    if (response != undefined) {

                        if (response.error) {
                            if (
                                response.message &&
                                response.message == "message.form.copy.failure"
                            ) {
                                EventBus.$emit("error-notification", {
                                    msg: constantMessages.MESSAGES[response.message]
                                });
                            } else {
                                for (let k in response.messages) {
                                    if (k.indexOf("duplicateName") != -1) {
                                        displayErrorMessage($(self.$refs.formName[response.messages[k]]), constantMessages.MESSAGES["error.form.duplicatename.add"])
                                        self.$refs.formName[response.messages[k]].classList.add("ms-is-invalid")
                                    } else if (k.indexOf("duplicateFormName") != -1) {
                                        displayErrorMessage($(self.$refs.formName[response.messages[k]]), constantMessages.MESSAGES["error.formcopy.duplicate.name.add"])
                                        self.$refs.formName[response.messages[k]].classList.add("ms-is-invalid")
                                    } else if (k.indexOf("owaspName") != -1) {
                                        displayErrorMessage($(self.$refs.formName[response.messages[k]]), constantMessages.MESSAGES["error.input.owasp.error"])
                                        self.$refs.formName[response.messages[k]].classList.add("ms-is-invalid")
                                    }
                                    if (k.indexOf("duplicateKey") != -1) {
                                        displayErrorMessage($(self.$refs.formKey[response.messages[k]]), constantMessages.MESSAGES["error.form.duplicatekey.add"])
                                        self.$refs.formKey[response.messages[k]].classList.add("ms-is-invalid")
                                    } else if (k.indexOf("duplicateFormKey") != -1) {
                                        displayErrorMessage($(self.$refs.formKey[response.messages[k]]), constantMessages.MESSAGES["error.form.duplicate.key.add"])
                                        self.$refs.formKey[response.messages[k]].classList.add("ms-is-invalid")
                                    } else if (k.indexOf("owaspKey") != -1) {
                                        displayErrorMessage($(self.$refs.formKey[response.messages[k]]), constantMessages.MESSAGES["error.input.owasp.error"])
                                        self.$refs.formKey[response.messages[k]].classList.add("ms-is-invalid")
                                    }
                                }
                            }
                        } else {
                            self.$router.push(
                                self.CONTEXT_PATH + "/design/applications/" + self.selectedApp
                            );

                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => { });
        },
        updateFormName(event, fieldIndex) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.formName[fieldIndex]), constantMessages.MESSAGES["error.formcopy.name.required"])
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.formName[fieldIndex]), constantMessages.MESSAGES["error.formcopy.maxLength.50"])
            } else if (!event.target.value.match(self.nameRegex)) {
                displayErrorMessage($(self.$refs.formName[fieldIndex]), constantMessages.MESSAGES["error.formcopy.name.invalid"])
            } else {
                self.$refs.formName[fieldIndex].classList.remove("ms-is-invalid")
            }
            this.applicationForms.forms[fieldIndex].name = event.target.value;
        },
        updateKey(event, fieldIndex) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.formKey[fieldIndex]), constantMessages.MESSAGES["error.key.required"])
                self.$refs.formKey[fieldIndex].classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.formKey[fieldIndex]), constantMessages.MESSAGES["error.key.length"])
                self.$refs.formKey[fieldIndex].classList.add("ms-is-invalid")
            } else if (!event.target.value.match(self.formKeyRegex)) {
                displayErrorMessage($(self.$refs.formKey[fieldIndex]), constantMessages.MESSAGES["error.key.invalid"])
                self.$refs.formKey[fieldIndex].classList.add("ms-is-invalid")
            } else {
                self.$refs.formKey[fieldIndex].classList.remove("ms-is-invalid")
            }
            this.applicationForms.forms[fieldIndex].key = event.target.value;
        },
        getFormName(index) {
            return "appForm" + index + "name";
        },
        getFormKeyName(index) {
            return "appForm" + index + "key";
        },
        redirectToList() {
            localStorage.setItem("FormList", "FormList");

            this.$router.push(this.CONTEXT_PATH + "/design/forms");
        }
    }
};
</script>
<style scoped></style>
